import { render, staticRenderFns } from "./ProductGridItem.vue?vue&type=template&id=65317d3c&"
import script from "./ProductGridItem.vue?vue&type=script&lang=js&"
export * from "./ProductGridItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductGridItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports